import { render, staticRenderFns } from "./user-order-item.vue?vue&type=template&id=54a9e002&scoped=true"
import script from "./user-order-item.vue?vue&type=script&lang=js"
export * from "./user-order-item.vue?vue&type=script&lang=js"
import style0 from "./user-order-item.vue?vue&type=style&index=0&id=54a9e002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9e002",
  null
  
)

export default component.exports